<template>
  <div class="help">

    <el-col :xs="{offset: 1, span: 22}" :md="{offset: 4, span: 16}" class="login">
      <div class="panelheader">
        <div class="title">{{pageName}}</div>
      </div>

      <div class="help-wrapper">
        <ul>

          <li>
            <div class="h">Check here for common problems</div>
            <a href="http://sporte.io/manual">User Manual</a>
          </li>

          <li>
            <div class="h">Something not working correctly?</div>
            <a href="http://sporte.io/faults">Fault Reports</a>
          </li>

          <li>
            <div class="h">Email us</div>
            <a href="mailto:hello@sporte.io">hello@sporte.io</a>
          </li>

          <li>
            <div class="h">Support phone number</div>
            <div>1300 559 165</div>
          </li>

        </ul>
      </div>

    </el-col>
  </div>
</template>

<script>
export default {
  name: 'help',
  data () {
    return {
      pageName: "Help and Support"
    }
  }
}
</script>

<style>

  .help-wrapper {
    padding: 20pt;
    background: white;
  }

  .help-wrapper ul {
    list-style: none;
    font-size: 150%;
  }

  .help-wrapper li {
    padding: 16px;
  }

  .help-wrapper .h {
    margin-bottom: 8px;
    font-size: 105%;
  }

  .help-wrapper a {
    color: #3DA8B9;
  }

</style>



// WEBPACK FOOTER //
// Help.vue?60ee3982